import { useMemo } from "react";

// Icons
import { TbChartAreaLine } from "react-icons/tb";

// Types
import type { IResultProps } from "./types";

export function Result({ TOTAL_BUILD, TOTAL_TERRAIN, brokerageAmount, extraAmount, feeAmount, houseAmount }: IResultProps) {

    // AUX Variable
    const INVEST_AMOUNT = useMemo(() => extraAmount + brokerageAmount + feeAmount + TOTAL_BUILD + TOTAL_TERRAIN, [extraAmount, brokerageAmount, feeAmount, TOTAL_BUILD, TOTAL_TERRAIN])
    const LUCRO_DO_EMPREENDIMENTO = useMemo(() => Math.max(houseAmount, INVEST_AMOUNT) - Math.min(houseAmount, INVEST_AMOUNT), [houseAmount, INVEST_AMOUNT])

    return (
        <span style={{
            maxWidth: 'calc(50% - 0.75rem)',
            minWidth: 'calc(50% - 0.75rem)',
        }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-start gap-3
                rounded-xl
                border-slate-200 border-[1px]
                bg-white shadow-md overflow-hidden
            "
        >
            <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                <TbChartAreaLine size={25} />
                <span className="font-semibold">Resultado</span>
            </span>

            <span className="w-full h-auto flex flex-col gap-3 p-4">
                <span className="w-full h-auto cursor-pointer
                    flex flex-row items-center justify-between gap-4 
                    peer-checked/PF:p-2 peer-checked/PF:bg-slate-200 rounded-xl"
                >
                    <span>Investimento bruto</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            }).format(INVEST_AMOUNT)
                        }
                    </span>
                </span>

                <span className="w-full h-auto flex flex-row items-center justify-between gap-4 rounded-xl"
                >
                    <span>Pessoa Jurídica Presumido</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            }).format(LUCRO_DO_EMPREENDIMENTO)
                        }
                    </span>
                </span>
            </span>
        </span>
    )
}
